import Enum from '../enum'

/**
 * ホシツキ 表示する星の等級
 */
class ShowStarsOption extends Enum {
    static SHOW_1ST = 1; // 一等級だけ
    static SHOW_TO_2ND = 2; // 一等級・二等級の星
    static SHOW_TO_3RD = 3; // 一等級〜三等級の星
    static SHOW_TO_4TH = 4; // 一等級〜四等級の星
    static SHOW_ALL = 5; // 全ての星

    static values() {
        return {
            [this.SHOW_1ST]: '一等級だけ', // ← 運営・学校画面で文言が違うとややこしいので「停止中」から変更
            [this.SHOW_TO_2ND]: '一等級・二等級の星',
            [this.SHOW_TO_3RD]: '一等級〜三等級の星',
            [this.SHOW_TO_4TH]: '一等級〜四等級の星',
            [this.SHOW_ALL]: '全ての星',
        }
    }

    static values_grade_1() {
        return {
            [this.SHOW_1ST]: '一とうきゅうだけ', // ← 運営・学校画面で文言が違うとややこしいので「停止中」から変更
            [this.SHOW_TO_2ND]: '一とうきゅう・二とうきゅうのほし',
            [this.SHOW_TO_3RD]: '一とうきゅう〜三とうきゅうのほし',
            [this.SHOW_TO_4TH]: '一とうきゅう〜四とうきゅうのほし',
            [this.SHOW_ALL]: 'すべてのほし',
        }
    }
    static values_grade_2() {
        return {
            [this.SHOW_1ST]: '一とうきゅうだけ', // ← 運営・学校画面で文言が違うとややこしいので「停止中」から変更
            [this.SHOW_TO_2ND]: '一とうきゅう・二とうきゅうの星',
            [this.SHOW_TO_3RD]: '一とうきゅう〜三とうきゅうの星',
            [this.SHOW_TO_4TH]: '一とうきゅう〜四とうきゅうの星',
            [this.SHOW_ALL]: 'すべての星',
        }
    }

    //学年ごとの翻訳選択肢
    static options(grade) {
        let object = this.values();
        let object_grade_1 = this.values_grade_1();
        let object_grade_2 = this.values_grade_2();
        let array = [];
        let keys = Object.keys(object);
        let label = ''
        keys.forEach((key) => {
            //1年生の場合
            if (grade === 1) {
                label = object_grade_1[key];
            //2年生の場合
            } else if (grade === 2) {
                label = object_grade_2[key];
            //その他の学年
            } else {
                label = object[key];
            }
            array.push({
                key: key,
                label: label,
            });
        });

        return array;
    }

    //一等級を表示する星グループ
    static keysShow1st() {
        return [
            this.SHOW_1ST,
            this.SHOW_TO_2ND,
            this.SHOW_TO_3RD,
            this.SHOW_TO_4TH,
            this.SHOW_ALL,
        ]
    }

    //二等級を表示する星グループ
    static keysShow2nd() {
        return [
            this.SHOW_TO_2ND,
            this.SHOW_TO_3RD,
            this.SHOW_TO_4TH,
            this.SHOW_ALL,
        ]
    }

    //三等級を表示する星グループ
    static keysShow3rd() {
        return [
            this.SHOW_TO_3RD,
            this.SHOW_TO_4TH,
            this.SHOW_ALL,
        ]
    }

    //四等級を表示する星グループ
    static keysShow4th() {
        return [
            this.SHOW_TO_4TH,
            this.SHOW_ALL,
        ]
    }

    //すべての星を表示する星グループ
    static keysShowAll() {
        return [
            this.SHOW_ALL,
        ]
    }
}

export default ShowStarsOption;
